import type { FC, ReactNode } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { Condition, type Props as ConditionProps } from './Condition';
import { Period, type Props as PeriodProps } from './Period';

type Props = {
  periodProps: PeriodProps;
  conditionProps: ConditionProps;
  upperDecorationImage?: {
    url: string;
    mobileWidth: number;
    mobileHeight: number;
    desktopWidth: number;
    desktopHeight: number;
  };
  lowerDecorationImage?: {
    url: string;
    mobileWidth: number;
    mobileHeight: number;
    desktopWidth: number;
    desktopHeight: number;
  };
  nextPageIcon?: ReactNode;
  content?: ReactNode;
};

export const CampaignDetails: FC<Props> = ({
  periodProps,
  conditionProps,
  upperDecorationImage,
  lowerDecorationImage,
  nextPageIcon,
  content
}) => (
  <section className="flex flex-col gap-5 semiLg:gap-10 p-10 px-4 relative">
    {upperDecorationImage && (
      <div className="semiLg:hidden absolute top-0 left-0">
        <NextImage
          src={upperDecorationImage.url}
          alt="upper-decoration-image"
          width={upperDecorationImage.mobileWidth}
          height={upperDecorationImage.mobileHeight}
        />
      </div>
    )}
    {upperDecorationImage && (
      <div className="hidden semiLg:flex absolute top-0 left-0">
        <NextImage
          src={upperDecorationImage.url}
          alt="upper-decoration-image"
          width={upperDecorationImage.desktopWidth}
          height={upperDecorationImage.desktopHeight}
        />
      </div>
    )}
    <div className="flex flex-col gap-10 semiLg:gap-20">
      <Period {...periodProps} />
      <Condition {...conditionProps} />
    </div>
    {nextPageIcon && <div className="flex justify-center items-center">{nextPageIcon}</div>}
    {content}
    {lowerDecorationImage && (
      <div className="semiLg:hidden absolute bottom-0 right-0 flex">
        <NextImage
          src={lowerDecorationImage.url}
          alt="lower-decoration-image"
          width={lowerDecorationImage.mobileWidth}
          height={lowerDecorationImage.mobileHeight}
        />
      </div>
    )}
    {lowerDecorationImage && (
      <div className="hidden semiLg:flex absolute bottom-0 right-0">
        <NextImage
          src={lowerDecorationImage.url}
          alt="lower-decoration-image"
          width={lowerDecorationImage.desktopWidth}
          height={lowerDecorationImage.desktopHeight}
        />
      </div>
    )}
  </section>
);
